import React from "react";
import PropTypes from "prop-types";
import {
  HeaderBody,
  HeaderItem,
  DisplayHeader,
  UserItems
} from "./HeaderStyle";
import Avatar from "./avatar/Avatar";

function Header(props) {
  return (
    <HeaderBody>
      <DisplayHeader>
        <HeaderItem style={{ marginLeft: "40px" }}><img style={{    width: "124px"}} src="/favicon/fiskal.svg" /></HeaderItem>
        <HeaderItem>
          <UserItems>
            <Avatar />
          </UserItems>
        </HeaderItem>
      </DisplayHeader>
    </HeaderBody>
  );
}

Header.propTypes = {
  location: PropTypes.object
};
Header.defaultProps = {
  location: {}
};
export default Header;
